import { useState, useEffect } from 'react';
import { ContentHttpService } from "../services";
import { useToast } from './useToast';

interface UseCase {
  id: number;
  use_case_name: string;
  use_case_type: string;
  company: string;
  industry: string;
  tools: string;
  use_case_description: string;
  performance_impact: string;
  use_case_date: string;
  source: string;
  created_at: string;
  url_validation_score: number;
  relevance_score: number;
}

interface UseCaseResponse {
  results: UseCase[];
  count: number;
}

interface UseUseCasesProps {
  page: number;
  pageSize: number;
  searchQuery: string;
  themeId?: number;
}

export const useUseCases = ({ page, pageSize, searchQuery, themeId }: UseUseCasesProps) => {
  const [useCases, setUseCases] = useState<UseCase[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const { showToast } = useToast();

  const fetchUseCases = async () => {

    try {
      setUseCases([]);
      setIsLoading(true);
      const data = await ContentHttpService.loadUseCases(themeId, searchQuery, page, pageSize) as UseCaseResponse;
      setUseCases(data.results);
      setTotalCount(data.count);
    } catch (error) {
      console.error('Error fetching use cases:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGenerateReport = async (themeId?: number) => {
    try {
      showToast({
        type: 'success',
        title: 'Use case search started',
        message: 'Use case search started. The steps and thinking process are displayed below the use case list.'
      });
      const response = await ContentHttpService.generateUseCaseReport(themeId);

      if (response) {
        await fetchUseCases();
      }
    } catch (error) {
      console.error('Error generating report:', error);
    } finally {
    }
  };

  useEffect(() => {
    setUseCases([]);
    fetchUseCases();
  }, [page, pageSize, searchQuery, themeId]);

  return {
    useCases,
    totalCount,
    isLoading,
    handleGenerateReport,
    refetch: fetchUseCases
  };
}; 